import { TranslationKeys } from '@/@types/keys/translation'

import i18n from '..'

// Função utilitária para traduções fora de componentes
export const translate = (
  key: TranslationKeys,
  options?: Record<string, unknown>,
): string => {
  return i18n.t(key, options)
}
